<template>
  <div class="row">
    <div class="col-sm-6 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA FACTURACIÓN: </label>
        <span>{{ order.billingDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA PRIMER PAGO: </label>
        <span>{{ order.firstPaymentDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">CANTIDAD DE PAGOS: </label>
        <span>{{ order.payments }}</span>
      </div>
    </div>

    <div v-if="order.dollarQuotation" class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA COTIZACIÓN DOLAR: </label>
        <span>{{ order.dollarQuotation.date | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">TIPO COTIZACIÓN: </label>
        <span>{{ order.dollarQuotationType | capitalize }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
        <span>{{ dollarQuote | toCurrencyARS }}</span>
      </div>
    </div>

    <div v-else class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA COTIZACIÓN DOLAR: </label>
        <span>{{ order.dollarQuoteDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
        <span>{{ +order.dollarQuote | toCurrencyARS }}</span>
      </div>
    </div>

    <div v-if="order.comment" class="col-sm-12 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">OBSERVACIONES: </label>
        <span>{{ order.comment }}</span>
      </div>
    </div>

    <div v-if="order.statusChangeComment" class="col-sm-12 col-xs-12">
      <div class="mt-2">
        <label class="control-label font-weight-bold mr-2">OBSERVACIONES SOBRE ESTADO DE PEDIDO: </label>
        <span>{{ order.statusChangeComment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dollarQuote() {
      return Number(this.order.dollarQuotation[this.order.dollarQuotationType]);
    },
  },
};
</script>
